function LoadingSpinner({ label, sublabel, size = "md", layout = "column", className = "" }) {
  const rootClass = ["loading-spinner-block", layout === "row" ? "loading-spinner-block--row" : "", className]
    .filter(Boolean)
    .join(" ");

  const aria = label || sublabel || "Loading";

  return (
    <div className={rootClass} role="status" aria-busy="true" aria-label={aria}>
      <span className={`loading-spinner loading-spinner--${size}`} aria-hidden="true" />
      {(label || sublabel) && (
        <div className="loading-spinner-copy">
          {label ? <span className="loading-spinner-label">{label}</span> : null}
          {sublabel && layout === "column" ? (
            <span className="loading-spinner-sublabel">{sublabel}</span>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default LoadingSpinner;
